(() => {
  const SESSION_KEY = 'rb:pillow-landing-session:v2';
  const LEGACY_KEY = 'rb:pillow-landing:v1';
  const MAIN_HANDLE = 'restingbelly-maternity-pillow';
  const LANDING_HANDLES = new Set([
    'restingbelly-maternity-pillow-3',
    'restingbelly-maternity-pillow-2',
    'restingbelly-maternity-pillow-1',
  ]);

  const productHandleFromUrl = (url) => {
    const parts = url.pathname.split('/');
    const productsIndex = parts.lastIndexOf('products');
    if (productsIndex === -1 || productsIndex + 1 >= parts.length) return null;
    return decodeURIComponent(parts[productsIndex + 1]);
  };

  const urlWithHandle = (url, handle) => {
    const updated = new URL(url.href);
    const parts = updated.pathname.split('/');
    const productsIndex = parts.lastIndexOf('products');
    if (productsIndex === -1 || productsIndex + 1 >= parts.length) return null;
    parts[productsIndex + 1] = handle;
    updated.pathname = parts.join('/');
    return updated;
  };

  const clearLegacyChoice = () => {
    try {
      localStorage.removeItem(LEGACY_KEY);
    } catch (_error) {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  };

  const saveSessionChoice = (handle) => {
    if (!LANDING_HANDLES.has(handle)) return;
    try {
      sessionStorage.setItem(SESSION_KEY, handle);
    } catch (_error) {
      // Without session storage, normal product navigation remains unchanged.
    }
  };

  const clearSessionChoice = () => {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (_error) {
      // Ignore unavailable storage.
    }
  };

  const readSessionChoice = () => {
    try {
      const handle = sessionStorage.getItem(SESSION_KEY);
      return LANDING_HANDLES.has(handle) ? handle : null;
    } catch (_error) {
      return null;
    }
  };

  const isSameOriginReferrer = () => {
    if (!document.referrer) return false;
    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch (_error) {
      return false;
    }
  };

  clearLegacyChoice();

  const currentUrl = new URL(window.location.href);
  const currentHandle = productHandleFromUrl(currentUrl);
  const navigationType = performance.getEntriesByType('navigation')[0]?.type;

  if (LANDING_HANDLES.has(currentHandle)) {
    saveSessionChoice(currentHandle);
  } else if (
    currentHandle === MAIN_HANDLE ||
    (navigationType !== 'reload' && navigationType !== 'back_forward' && !isSameOriginReferrer())
  ) {
    // The main PDP and every fresh direct/external visit always start without campaign context.
    clearSessionChoice();
  }

  const sessionHandle = readSessionChoice();
  if (!sessionHandle) return;

  const rewriteLink = (link) => {
    if (!(link instanceof HTMLAnchorElement) || !link.href) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return;
    }

    if (url.origin !== window.location.origin || productHandleFromUrl(url) !== MAIN_HANDLE) return;

    const destination = urlWithHandle(url, sessionHandle);
    if (destination) link.href = destination.href;
  };

  const rewriteLinks = (root) => {
    if (root instanceof HTMLAnchorElement) rewriteLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(rewriteLink);
  };

  rewriteLinks(document);

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest ? event.target.closest('a[href]') : null;
      if (link) rewriteLink(link);
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) rewriteLinks(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
